export default __webpack_public_path__ + "static/media/ast-auto2.44b54926.jpg";